import { Component, HostBinding, inject, Input, Output, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { HomeCardComponentHost } from '@tytapp/app/pages/home-page/home-card-component-host.component';
import { HomeCard, HomeCardComponentType, HomeCardComponentTypeRegistration, HomeCardsService } from '@tytapp/app/pages/home-page/home-cards.service';
import { Subject } from 'rxjs';

@Component({
    selector: 'tyt-home-card',
    templateUrl: './home-card.component.html',
    styleUrls: ['./home-card.component.scss']
})
export class HomeCardComponent {
    private homeCardsService = inject(HomeCardsService);
    private domSanitizer = inject(DomSanitizer);

    @Output() removed = new Subject<void>();

    @HostBinding('class.animate-in')
    animateIn = false;

    @HostBinding ('class.full-bleed')
    get fullBleed() {
        return this.component?.fullBleed;
    }
    @HostBinding ('class.hidden')
    get hidden() {
        if (this.enableDevTools && (this.forceVisible || this.showInfo))
            return false;

        return this.component?.hidden === true;
    }

    @Input()
    forceVisible = false;

    @HostBinding('class')
    get class() {
        let classes = [];
        if (this.component?.classes) {
            classes.push(...this.component.classes);
        }

        return classes.join(' ');
    }

    @Input() primary = false;

    private _card: HomeCard;
    @Input() get card() { return this._card; }
    set card(value) {
        if (this._card === value)
            return;
        this._card = value;
        this.type = this.homeCardsService.getType(value.type);
        setTimeout(() => this.animateIn = true, 1);
    }

    type: HomeCardComponentTypeRegistration;
    component: HomeCardComponentType;

    @Input() enableDevTools: boolean;

    @ViewChild('componentHost')
    componentHost: HomeCardComponentHost;

    @Input() showInfo = false;

    reload() {
        this.componentHost.reload();
    }

    remove() {
        this.removed.next();
    }
}